import React from 'react';
import { injectIntl } from 'react-intl';

import noPageAndBusiness from 'assets/bosta-images/Speachbubble .png';

const SelectPageEmptyState = ({ intl }) => {
  return (
    <div className="br-select-page-empty-state__container">
      <img src={noPageAndBusiness} alt="no page and business" />
      <span className="display-xs">
        {intl.formatMessage({
          id: 'chats_plugins.chats_page.meta_account_required'
        })}
      </span>
      <span className="br-select-page-empty-state__body">
        {intl.formatMessage(
          {
            id: 'chats_plugins.chats_page.create_meta_account'
          },
          {
            spanLink: (children) => (
              <a
                href="https://business.facebook.com/overview"
                className="br-select-page-empty-state__create-account"
              >
                {children}
              </a>
            )
          }
        )}
      </span>
    </div>
  );
};

export default injectIntl(SelectPageEmptyState);
